import type { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * English and French letters, digits, spaces, and printable characters that are not
 * explicitly prohibited. Comma is allowed. Control characters and other scripts are not.
 */
const DELIVERY_INSTRUCTIONS_ALLOWED_CHARACTERS_REGEX =
  /^[ !"#$%&'()+,\-.0-9:;=?@A-Z[\]_`a-zÀÂÄÆÇÈÉÊËÎÏÔŒÙÛÜŸàâäæçèéêëîïôœùûüÿ]*$/;

/** Error keys used by the delivery instructions validator. */
export const DELIVERY_INSTRUCTIONS_VALIDATION_ERROR_KEYS = {
  restrictedCharacters: 'deliveryInstructionsRestrictedCharacters',
} as const;

/**
 * Validates optional delivery instructions against carrier-prohibited characters.
 * Empty values are allowed. Prohibited characters, controls, and non-English/French
 * letters block the field so the shipment cannot be created with that text.
 */
export function optionalDeliveryInstructionsCharactersValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = typeof control.value === 'string' ? control.value.trim() : '';

  if (!value) {
    return null;
  }

  return DELIVERY_INSTRUCTIONS_ALLOWED_CHARACTERS_REGEX.test(value)
    ? null
    : { [DELIVERY_INSTRUCTIONS_VALIDATION_ERROR_KEYS.restrictedCharacters]: true };
}
